// extracted by mini-css-extract-plugin
export default {"LegendInputWrapper":"LegendInput_LegendInputWrapper__mK4rm","LegendInput":"LegendInput_LegendInput__cFDYw","LegendTitle":"LegendInput_LegendTitle__1ivwV"};